import { gql } from '@apollo/client';

export const getBreadcrambsArticleQuery = gql`
  query getBreadcrambsArticleQuery($articleId: ID) {
    article(where: { id: $articleId }) {
      id
      title
      slug
      coverImage {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
      territory {
        id
        name
        logo {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
        slug
      }
    }
  }
`;
